module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "results"
    }
  }, [(_vm.classes === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.classes.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_data']))])]) : _vm._e(), _vm._l((_vm.classes), function(cls) {
    return _c('nav', {
      key: cls.ref.id,
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-block is-marginless is-paddingless"
    }, [_c('div', {
      staticClass: "card is-fullwidth"
    }, [_c('header', {
      staticClass: "card-header notification is-info is-paddingless"
    }, [_c('div', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(cls.ref.name))])]), _c('div', {
      staticClass: "card-content"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['tasks']))]), _c('th'), _c('th'), _c('th'), _c('th')])]), _c('tbody', _vm._l((_vm.tasksWithSessions(cls.tasks)), function(task) {
      return _c('tr', {
        key: task.id
      }, [_c('td', [_vm._v(_vm._s(task.name))]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.durations)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_durations']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.gazeReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_gaze_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.wordReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_word_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded || !task.hasQuestionnaire
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.questionnaireResults)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_questionnaire']))])])])
    }))]), (cls.students === null) ? _c('div', {
      staticClass: "container"
    }, [_c('loading')], 1) : (!cls.students.length) ? _c('div', {
      staticClass: "container"
    }) : _c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['students']))]), _c('th'), _c('th'), _c('th'), _c('th'), _c('th'), _c('th', [_c('button', {
      staticClass: "button is-primary is-pulled-right",
      attrs: {
        "disabled": !_vm.isLoaded
      },
      on: {
        "click": function($event) {
          _vm.selectClassStudents(cls, _vm.VISUALIZATIONS.studentsSummary)
        }
      }
    }, [_vm._v(_vm._s(_vm.tokens['btn_summary']))])])])]), _c('tbody', _vm._l((cls.students), function(student) {
      return _c('tr', {
        key: student.ref.id
      }, [_c('td', [_vm._v(_vm._s(student.ref.name))]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-warning",
        attrs: {
          "disabled": !_vm.isLoaded || !student.sessions.length
        },
        on: {
          "click": function($event) {
            _vm.editSessions(student)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_edit']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.gazePlot)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_gaze_plot']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded || !_vm.hasItems(student, _vm.filterHasAudio)
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.audioReplay, _vm.filterHasAudio)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_audio_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.durations)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_durations']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.gazeReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_gaze_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.wordReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_word_replay']))])])])
    }))])])])])])
  }), (_vm.gradeWithStudents) ? _c('modal-container', {
    attrs: {
      "title": _vm.gradeWithStudents[0].text
    },
    on: {
      "close": _vm.closeStudentSelectionBox
    }
  }, [_c('item-selection-box', {
    attrs: {
      "items": _vm.gradeWithStudents,
      "item-name": _vm.tokens['data_grade'],
      "subitem-name": _vm.tokens['data_student']
    },
    on: {
      "accept": _vm.continueDeferredWithStudents
    }
  })], 1) : _vm._e(), (_vm.studentWithSessions) ? _c('modal-container', {
    attrs: {
      "title": _vm.studentWithSessions[0].text
    },
    on: {
      "close": _vm.closeSessionSelectionBox
    }
  }, [_c('item-selection-box', {
    attrs: {
      "multiple": !_vm.isMultipleSessions,
      "single-group": !_vm.isMultipleSessions && !_vm.studentWithSessions[0].multiGroup,
      "items": _vm.studentWithSessions,
      "item-name": _vm.tokens['data_grade'],
      "subitem-name": _vm.tokens['data_session']
    },
    on: {
      "accept": _vm.continueDeferredWithSessions
    }
  })], 1) : _vm._e(), (_vm.editingStudent) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_sessions'](_vm.editingStudent.ref.name)
    },
    on: {
      "close": _vm.closeSessionEditingBox
    }
  }, [_c('session-editing-box', {
    attrs: {
      "student": _vm.editingStudent
    },
    on: {
      "deleted": _vm.sessionDeleted
    }
  })], 1) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.gazePlot)) ? _c('gaze-plot', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.audioReplay)) ? _c('gaze-with-audio', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.durations)) ? _c('durations', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.gazeReplay)) ? _c('gaze-replay', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.wordReplay)) ? _c('word-replay', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.questionnaireResults)) ? _c('questionnaire-results', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.studentsSummary)) ? _c('students-summary', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5850bae0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/Results.vue
// module id = 424
// module chunks = 0